export const CONTACT = 'CONTACT';
export const COMPANY = 'COMPANY';
export const DEAL = 'DEAL';
export const TICKET = 'TICKET';
export const QUOTE = 'QUOTE';
export const ENGAGEMENT = 'ENGAGEMENT';
export const LINE_ITEM = 'LINE_ITEM';
export const PAYMENT = 'PAYMENT';
export const GOAL_TARGET = 'GOAL_TARGET';
export const ORDER = 'ORDER';
export const CART = 'CART';
export const INVOICE = 'INVOICE';
export const LEAD = 'LEAD';
export const CALL = 'CALL';
export const USER = 'USER';
export const PARTNER_ACCOUNT = 'PARTNER_ACCOUNT';
export const PARTNER_CLIENT = 'PARTNER_CLIENT';
export const PARTNER_SERVICE = 'PARTNER_SERVICE';
export const SERVICE = 'SERVICE';
export const COURSE = 'COURSE';
export const LISTING = 'LISTING';
export const APPOINTMENT = 'APPOINTMENT';
export const NOTE = 'NOTE';
export const MEETING_EVENT = 'MEETING_EVENT';
export const EMAIL = 'EMAIL';
export const CONVERSATION_SESSION = 'CONVERSATION_SESSION';
export const COMMUNICATION = 'COMMUNICATION';
export const POSTAL_MAIL = 'POSTAL_MAIL';
export const TASK = 'TASK';
export const UNKNOWN = 'UNKNOWN';
export const UNKNOWN_ID = '0-0';
export const CONTACT_ID = '0-1';
export const COMPANY_ID = '0-2';
export const DEAL_ID = '0-3';
export const ENGAGEMENT_ID = '0-4';
export const TICKET_ID = '0-5';
export const PRODUCT_ID = '0-7';
export const LINE_ITEM_ID = '0-8';
export const CONVERSATION_ID = '0-11';
export const QUOTE_ID = '0-14';
export const COMMUNICATION_ID = '0-18';
export const FEEDBACK_SUBMISSION_ID = '0-19';
export const TASK_ID = '0-27';
export const CAMPAIGN_ID = '0-35';
export const AUTOMATION_PLATFORM_FLOW_ID = '0-44';
export const OBJECT_LIST_ID = '0-45';
export const NOTE_ID = '0-46';
export const MEETING_EVENT_ID = '0-47';
export const CALL_ID = '0-48';
export const EMAIL_ID = '0-49';
export const CONVERSATION_SESSION_ID = '0-51';
export const INVOICE_ID = '0-53';
export const QUOTE_TEMPLATE_ID = '0-64';
export const SUBSCRIPTION_ID = '0-69';
export const GOAL_TARGET_ID = '0-74';
export const DISCOUNT_ID = '0-84';
export const PAYMENT_ID = '0-101';
export const DISCOUNT_CODE_ID = '0-110';
export const USER_ID = '0-115';
export const POSTAL_MAIL_ID = '0-116';
export const SUBMISSION_TAG_ID = '0-119';
export const ORDER_ID = '0-123';
export const MARKETING_SMS_ID = '0-124';
export const LEAD_ID = '0-136';
export const ABANDONED_CART_ID = '0-137';
export const CART_ID = '0-142';
export const PARTNER_ACCOUNT_ID = '0-125';
export const PARTNER_CLIENT_ID = '0-145';
export const PARTNER_SERVICE_ID = '0-164';
export const SERVICE_ID = '0-162';
export const COURSE_ID = '0-410';
export const LISTING_ID = '0-420';
export const APPOINTMENT_ID = '0-421';
/**
 * From https://git.hubteam.com/HubSpot/customer-data-objects/blob/f41a714e70ccddeee4c5fa3e2cece37c7edeec34/static/js/constants/ObjectTypeIds.ts#L91-L106
 *
 * Object type ids are formatted as "<meta type id>-<inner id>"
 *
 * We don't want to hard-code the complete list of HubSpot-defined
 * object type ids, as new ones can be created dynamically using
 * the Framework Builder. Similarly, it's not possible to hard-code
 * portal-specific object type ids such as "2-123", as they differ
 * for each portal.
 *
 * TypeScript also has no way to define a type that matches a regex.
 * Otherwise we would limit this to /\d+-\d+/ (possibly further
 * restricted to only known meta type ids).
 *
 * See https://github.com/microsoft/TypeScript/issues/41160
 * See https://github.com/microsoft/TypeScript/issues/6579
 */

export const SAME_OBJECT_ASSOCIATION_ENROLLED_OBJECT = 'enrolled_object';
// The Fully Qualified Name of a HubSpot-defined object type is identical to its
// Object Type Name
export const CONTACT_FQN = CONTACT;
export const ToObjectTypeId = {
  [UNKNOWN]: UNKNOWN_ID,
  [CONTACT]: CONTACT_ID,
  [COMPANY]: COMPANY_ID,
  [DEAL]: DEAL_ID,
  [TICKET]: TICKET_ID,
  [QUOTE]: QUOTE_ID,
  [ENGAGEMENT]: ENGAGEMENT_ID,
  [LINE_ITEM]: LINE_ITEM_ID,
  [PAYMENT]: PAYMENT_ID,
  [GOAL_TARGET]: GOAL_TARGET_ID,
  [ORDER]: ORDER_ID,
  [CART]: CART_ID,
  [INVOICE]: INVOICE_ID,
  [LEAD]: LEAD_ID,
  [CALL]: CALL_ID,
  [USER]: USER_ID,
  [PARTNER_ACCOUNT]: PARTNER_ACCOUNT_ID,
  [PARTNER_CLIENT]: PARTNER_CLIENT_ID,
  [PARTNER_SERVICE]: PARTNER_SERVICE_ID,
  [SERVICE]: SERVICE_ID,
  [COURSE]: COURSE_ID,
  [LISTING]: LISTING_ID,
  [APPOINTMENT]: APPOINTMENT_ID,
  [TASK]: TASK_ID
};

/**
 * DEPRECATED
 *
 * This reverse list from object type id to object type is a
 * crutch for unmigratable features. It should not be used
 * unless absolutely necessary.
 *
 * An example of this are "external option requests" which are
 * only ever used by the original hubspot objects like Deals
 * and Tickets.
 */
export const ToObjectType = {
  [UNKNOWN_ID]: UNKNOWN,
  [CONTACT_ID]: CONTACT,
  [COMPANY_ID]: COMPANY,
  [DEAL_ID]: DEAL,
  [TICKET_ID]: TICKET,
  [QUOTE_ID]: QUOTE,
  [ENGAGEMENT_ID]: ENGAGEMENT,
  [LINE_ITEM_ID]: LINE_ITEM,
  [ORDER_ID]: ORDER,
  [CART_ID]: CART,
  [LEAD_ID]: LEAD
};